import { useForm } from '@refinedev/antd';
import { Edit } from '@refinedev/antd';
import { Form, Input, Switch, Card, Row, Col } from 'antd';
import { LabelWithHelp, SectionTitle } from '../../components/ui/HelpTooltip';

export const AppUpdateEdit = () => {
  const { formProps, saveButtonProps } = useForm({
    resource: 'admin/app-updates',
    redirect: 'list',
  });

  return (
    <Edit saveButtonProps={saveButtonProps} title="Yangilanishni tahrirlash">
      <Form {...formProps} layout="vertical">
        <Row gutter={24}>
          <Col xs={24} lg={12}>
            <Card title={<SectionTitle title="Versiya ma'lumotlari" help="Versiya sozlamalari" />}>
              <Form.Item
                label={<LabelWithHelp label="Android versiyasi" help="Google Play Store dagi eng so'nggi versiya (semver: 1.2.3)" />}
                name="androidVersion"
                rules={[
                  { required: true, message: 'Android versiyasini kiriting' },
                  { pattern: /^\d+\.\d+\.\d+$/, message: 'Format: 1.2.3' },
                ]}
              >
                <Input placeholder="1.3.0" />
              </Form.Item>

              <Form.Item
                label={<LabelWithHelp label="iOS versiyasi" help="App Store dagi eng so'nggi versiya (semver: 1.2.3)" />}
                name="iosVersion"
                rules={[
                  { required: true, message: 'iOS versiyasini kiriting' },
                  { pattern: /^\d+\.\d+\.\d+$/, message: 'Format: 1.2.3' },
                ]}
              >
                <Input placeholder="1.2.0" />
              </Form.Item>

              <Form.Item
                label={<LabelWithHelp label="Majburiy yangilanish" help="Foydalanuvchi yangilanmasdan davom eta olmaydi" />}
                name="isMandatory"
                valuePropName="checked"
              >
                <Switch checkedChildren="Majburiy" unCheckedChildren="Ixtiyoriy" />
              </Form.Item>

              <Form.Item
                label={<LabelWithHelp label="Faol" help="Foydalanuvchilarga ko'rinadimi" />}
                name="isActive"
                valuePropName="checked"
              >
                <Switch checkedChildren="Ha" unCheckedChildren="Yo'q" />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card title={<SectionTitle title="Do'kon havolalari" help="Play Store va App Store havolalari" />}>
              <Form.Item
                label={<LabelWithHelp label="Play Store havola" help="Android uchun" />}
                name="playStoreUrl"
                rules={[{ required: true, message: 'Havolani kiriting' }]}
              >
                <Input placeholder="https://play.google.com/store/apps/..." />
              </Form.Item>

              <Form.Item
                label={<LabelWithHelp label="App Store havola" help="iOS uchun" />}
                name="appStoreUrl"
                rules={[{ required: true, message: 'Havolani kiriting' }]}
              >
                <Input placeholder="https://apps.apple.com/app/..." />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Card title={<SectionTitle title="O'zbekcha" help="O'zbek tilidagi izoh" />}>
              <Form.Item
                label="Yangilanish izohi"
                name="releaseNotesUz"
                rules={[{ required: true, message: 'Izohni kiriting' }]}
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Card title={<SectionTitle title="Ruscha" help="Rus tilidagi izoh" />}>
              <Form.Item
                label="Yangilanish izohi"
                name="releaseNotesRu"
                rules={[{ required: true, message: 'Izohni kiriting' }]}
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Card title={<SectionTitle title="Inglizcha" help="Ingliz tilidagi izoh" />}>
              <Form.Item
                label="Yangilanish izohi"
                name="releaseNotesEn"
                rules={[{ required: true, message: 'Izohni kiriting' }]}
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Card>
          </Col>
        </Row>
      </Form>
    </Edit>
  );
};
